import {
  CalendarClock,
  CheckSquare,
  FileText,
  Heart,
  Linkedin,
  Mail,
  Package,
  Phone,
  Presentation,
  Reply,
  Utensils,
} from "lucide-react";

/** Iconography for task types - used in task lists and the calendar. */
export const TASK_TYPE_ICONS: Record<string, typeof CheckSquare> = {
  none: CheckSquare,
  email: Mail,
  demo: Presentation,
  lunch: Utensils,
  meeting: CalendarClock,
  "follow-up": Reply,
  "thank-you": Heart,
  ship: Package,
  call: Phone,
  linkedin: Linkedin,
  quote: FileText,
};

export const taskTypeIcon = (type?: string) =>
  TASK_TYPE_ICONS[type ?? "none"] ?? CheckSquare;
